import React, { useState } from 'react';
import styles from './InitiateNewRegistration.styles.scss';
import { MainLayout } from '../../components/MainLayout';
import { PagesHeader } from '../../components/shared/PagesHeader';
import { useTranslation } from 'react-i18next';
import { ROUTES } from './InitiateNewRegistration.config';
import cn from 'classnames';
import { OvalSpinner } from '../../components/shared/OvalSpinner';
import { OTPs } from './components/OTPs';
import { ENVIRONEMNT, THEMES } from '../../constants/common';
import { usePageContext } from '../../context/pageContext';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router';
import { showToast } from '../../helpers/showToast';
import { NumberOfOTPs } from './components/NumberOfOTPs';
import { useAuthentication } from '../../hooks/useAuthentication';
import { generateOtp } from '../../services/apis';

const InitiateNewRegistration = () => {
  const { t } = useTranslation();
  const history = useNavigate();
  const { state } = usePageContext();

  const { userInfo } = useAuthentication();
  const [noOfOTPs, setNoOfOTPs] = useState('');
  const [apiLoading, setAPILoading] = useState(false);
  const [code, setCode] = useState();

  const handleChnage = (e) => {
    const { value } = e.target;
    setNoOfOTPs(value);
  };

  const handleGenerate = async (noOfOTPsP) => {
    const value = parseInt(noOfOTPsP, 10);

    // Validate before generating
    if (isNaN(value) || value < 1 || value > 100) {
      showToast({
        data: {
          variant: 'error',
          text: t('otp_validation_error'),
        },
      });
      return;
    }

    if (userInfo) {
      setAPILoading(true);
      await generateOtp(userInfo.tax_number, value)
        .then((resp) => {
          const otpArray = resp?.data?.OTPs?.map((otp) => otp.split(''));
          setCode(otpArray);
        })
        .finally(() => {
          setAPILoading(false);
        });
    }
  };

  const download = () => {
    if (state.otpTableRef?.current) {
      state.otpTableRef?.current?.exportCSV();
    } else {
      showToast({
        data: {
          variant: 'error',
          text: t('otp_export_error'),
        },
      });
    }
  };

  return (
    <MainLayout eInvoicing={true}>
      <PagesHeader
        withBreadcrumb={true}
        title={!code ? t('register-renew-device') : t('otp_code')}
        routes={ROUTES}
        wrapperClassName={'mb-2'}
      />

      {!code && (
        <>
          <div className="mb-5">
            <p className={styles.description}>{t('otp_generate_desc')}</p>
            <p className={cn(styles.description, styles.note)}>
              {t('note_an_otp')}
            </p>
          </div>
          <div style={{ width: 'fit-content' }}>
            <NumberOfOTPs
              noOfOTPs={noOfOTPs}
              onChange={handleChnage}
              onGenerate={handleGenerate}
              loading={apiLoading}
            />
            <Button
              className={cn('mt-5 px-5', styles.generateBtn)}
              size="medium"
              label={t('generate-otp-s')}
              disabled={
                !noOfOTPs ||
                isNaN(Number(noOfOTPs)) ||
                Number(noOfOTPs) < 1 ||
                Number(noOfOTPs) > 100
              }
              loading={apiLoading}
              onClick={() => {
                handleGenerate(noOfOTPs);
              }}
            />
          </div>
        </>
      )}

      {code?.[0] && (
        <>
          <p className={cn('mb-5', styles.description)}>{t('otp_page_desc')}</p>

          <div className={cn(styles.wrapper, 'mb-3')}>
            {apiLoading ? (
              <OvalSpinner
                color={THEMES[ENVIRONEMNT]?.primary}
                className={cn('mb-5', styles.loader)}
                width={30}
                height={30}
              />
            ) : (
              code?.[0] && <OTPs code={code} />
            )}
          </div>

          <div className={styles.actions}>
            <Button
              className={cn(styles.actionBtn, styles.backBtn)}
              label={t('common.back')}
              outlined
              onClick={() => {
                history('../', {
                  replace: false,
                  relative: true,
                });
              }}
            />
            <Button
              className={cn(styles.actionBtn, styles.exportBtn)}
              tooltip={t('tooltips.otp-export')}
              label={
                <>
                  {t('export_to_file')}{' '}
                  <i
                    className="pi pi-info-circle"
                    style={{ marginInlineStart: '8px' }}
                  />
                </>
              }
              onClick={download}
            />
          </div>
        </>
      )}
    </MainLayout>
  );
};

export default React.memo(InitiateNewRegistration);
